export default function Contact() {
  return (
    <>
      <div className="contactBody">
        <h3>Regional Office</h3>
        <p>Chhaygaon, Kamrup</p>
        <p>781001, Assam</p>
        <p>Email: info@forevereastwards.com</p>
        <p>Ph: +91 59015 69805</p>
      </div>

      <div className="contactBody">
        <h3>Head Quarters</h3>
        <p>Chandigarh</p>
        <p>781001, Punjab</p>
        <p>Email: info@forevereastwards.com</p>
        <p>Ph: +91 59015 69805</p>
      </div>
    </>
  );
}
